export enum PaymentMethod {
	PAYPAL = 'paypal',
	CASH = 'cash',
	CREDIT_CARD = 'credit_card',
	VISA = 'visa',
	MASTERCARD = 'mastercard',
	SEPA = 'sepa',
	BALANCE = 'balance',
	POS = 'pos',
	SOFORTBANKING = 'sofortbanking',
	GPAY = 'google_pay',
	APAY = 'apple_pay',
	CCV = 'ccv',
	ZERO_PAYMENT = 'zero_payment',
	ADYEN = 'adyen',
	WORLDLINE = 'worldline_raw',
	BONCARD = 'boncard',
	TWINT = 'twint',
	POSTFINANCE_CARD = 'postfinance_card',
	POSTFINANCE = 'postfinance',
	PIGGY_GIFT_CARD = 'piggy_gift_card',
	WALLEE = 'wallee',
	REKA = 'reka',
	LUNCHECK = 'luncheck',
	CARD_WORLDLINE = 'worldline',
}
